export default __webpack_public_path__ + "static/media/1535.c483a449.png";